/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'
import { Form, FormGroup, Label, Input, Button, ButtonGroup, ButtonToolbar, Row, Col, } from 'reactstrap'
import { css } from '@emotion/react';
import { RingLoader } from 'react-spinners'

import { CopyToClipboard } from 'react-copy-to-clipboard';

import ConfirmationModal from '../../widgets/ConfirmationModal'
import { AppContext } from '../../AppContext'

import prettyBytes from 'pretty-bytes';

class ObjectProperties extends React.Component
{

  weblink = null;
  closeConfirmationModal = null;

  componentDidMount()
  {
    if ('deleted' !== this.props.viewType)
    {
      this.generateWeblink(this.state.deliveryMethod);
      if ('STREAM' === this.state.deliveryMethod) this.generateWeblink('DOWNLOAD');  
    } 

    if (null !== window.getHelperApp(this.props.selectedObject.mimeType) && '' !== this.state.streamLink)
      this.generateWeblink('STREAM');
  }

  confirmCopyOrMove(action)
  {

    let modalText = 'Are you sure you want to ' + action + ' the data to object-storage?';
    this.closeConfirmationModal = this.copyOrMoveConfirmed.bind(this, action);
    this.setState({modalText: modalText, confirmationModalIsOpen: true});
  }

  async copyOrMoveConfirmed(action, confirmed)
  {
    this.setState({confirmationModalIsOpen: false});
    if (!confirmed) return;

    let bodyData = {action: action, objectId: this.props.selectedObject.objectId, objectType: this.props.selectedObject.objectType,
      fileExtension: this.props.selectedObject.fileExtension};
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'sendToObjectStorage', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error sending data to object storage.');
  }

  constructor(props)
  {
    super();

    let deliveryMethod = (null !== props.selectedObject.htmlElement ? 'STREAM' : 'DOWNLOAD');    
    
    this.deleteOrRestoreLabel = ('deleted' === props.viewType ? 'Restore' : 'Delete');

    this.state =
    {
      downloadLink: '',
      streamLink: '',
      deliveryMethod: deliveryMethod,
      confirmationModalIsOpen: false,
      modalText: undefined,
      metadata: undefined,
      spinnerIsSpinning: false,
      embeddingsGenerated: props.selectedObject.embeddingsGenerated,
      selectedObject: props.selectedObject
    }

    this.deleteRestoreOrPurge = this.deleteRestoreOrPurge.bind(this);
    this.spawnHelperApplication = this.spawnHelperApplication.bind(this);
    this.deliveryMethodChanged = this.deliveryMethodChanged.bind(this);
    this.setStorageTier = this.setStorageTier.bind(this);
    this.toggleCaptureDetail = this.toggleCaptureDetail.bind(this);
    this.generateEmbeddings = this.generateEmbeddings.bind(this);
    this.describeImage = this.describeImage.bind(this);
  }

  deleteRestoreOrPurge(buttonType)
  {
    let modalText = 'Are you sure that you want to delete this object?';

    if ('purge' === buttonType)
      modalText = 'Are you sure that you want to purge this object?  You will not be able to restore/recover the object if it has been purged.';

    if ('restore' === buttonType)
      modalText = 'Are you sure that you want to restore this object?';

    this.closeConfirmationModal = this.deleteRestoreOrPurgeConfirmed.bind(this, buttonType);
    this.setState({modalText: modalText, confirmationModalIsOpen: true});
  }

  deleteRestoreOrPurgeConfirmed(buttonType, confirmed)
  {
    this.setState({confirmationModalIsOpen: false});

    if (confirmed) 
    {
      this.props.deleteRestoreOrPurge(buttonType); 
      this.props.toggleModal();
    }
  }
  
  deliveryMethodChanged(deliveryMethod)
  {
    if ('DOWNLOAD' === deliveryMethod)
      this.setState({deliveryMethod: 'DOWNLOAD'});
    else
      this.setState({deliveryMethod: 'STREAM'});
  }

  async describeImage()
  {
    let bodyData = {objectId: this.props.selectedObject.objectId}
    this.setState({spinnerIsSpinning: true});
    this.context.postNotification('info', 'Generating an image description.');
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'describeImage', bodyData);
    this.setState({spinnerIsSpinning: false});
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Unable to describe the image.');
    this.context.postNotification('success', 'Image description generated.');
    let selectedObject = this.state.selectedObject;
    selectedObject.aiSummaryDescription = result.jsonData.aiSummaryDescription;
    this.setState({selectedObject});
  }

  async generateEmbeddings()
  {
    let bodyData = {selectedObjectIds: [this.props.selectedObject.objectId], viewType: this.props.viewType};
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'createEmbeddingsRequest', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error submitting embedding request');
    this.context.postNotification('info', 'Embedding generation request submited.');
    this.setState({embeddingsGenerated: 'Request Submitted'});
  }

  async generateWeblink(contentDisposition)
  {
    let bodyData = {objectId: this.props.selectedObject.objectId, contentDisposition: contentDisposition};
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'generateObjectWeblink', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error generating weblink');
    switch (contentDisposition)
    {
      case 'DOWNLOAD':
        this.setState({downloadLink: result.jsonData.objectWeblink});
        break;

      case 'STREAM':
        this.setState({streamLink: result.jsonData.objectWeblink});
        break;

      default:
        break;
    }
  }

  render()
  {
    let selectedObject = this.props.selectedObject;
    let buttonBar = this.renderButtonBar(selectedObject);
    const override = css`
      display: block;
      margin: 0 auto;
      border-color: red;
    `;

    return(
      <div>
        <div style={{position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}>
          <RingLoader
            css={override}
            size={75}
            color={'#4A90E2'}
            loading={this.state.spinnerIsSpinning}
          />          
        </div>
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2">Name</Col><Col>{selectedObject.objectName}</Col>
        </Row>
      {
        'shared' === this.props.viewType &&
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2">Owner</Col><Col>{selectedObject.ownerName}</Col>
        </Row>
      }
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2">Object Type</Col><Col>{selectedObject.objectType}</Col>
        </Row>
        { window.extensionEnabled(this.context.websiteProfile.installedExtensions, this.context.extensions.AI) &&
          null !== selectedObject.vectorModality &&
          <>
            <Row style={{paddingTop: "10px"}}>
              <Col sm="2">Embeddings Generated</Col>
              <Col sm='1'>{this.state.embeddingsGenerated}</Col>
              { ('Yes' === this.state.embeddingsGenerated || 'No' === this.state.embeddingsGenerated ||
                 'Failed' === this.state.embeddingsGenerated ) &&
                <Col sm='1'><Button id="generateEmbeddings" color='success' 
                  onClick={this.generateEmbeddings}>{this.state.embeddingsGenerated === 'Yes' ? 'Regenerate' : 'Generate'}</Button>
                </Col>
              }
            </Row>
            <Row style={{paddingTop: "10px"}}>
              <Col sm="2">Vector Modality</Col>
              <Col sm='1'>{selectedObject.vectorModality}</Col>
              { 'image' === selectedObject.vectorModality && 
                <Col sm='1'><Button id="describeImage" onClick={this.describeImage}>AI Describe</Button></Col>
              }
            </Row>
            { 'image' === selectedObject.vectorModality &&
              <Row style={{paddingTop: "10px"}}>
                <Col sm="2">Image Description</Col>
                <Col sm='4'>
                  <Input type="textarea" style={{height: "50px"}} id="aiSummaryDescription" value={this.state.selectedObject.aiSummaryDescription} disabled={true} />
                </Col>
              </Row>
            }
          </>
        }
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2">Source</Col><Col>{selectedObject.sourcePath}</Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2">Size</Col><Col>{new Intl.NumberFormat().format(parseInt(selectedObject.contentLength, 10))} Bytes ({prettyBytes(parseInt(selectedObject.contentLength, 10))})</Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2">Creation Date</Col><Col>{window.formatTimestamp(selectedObject.creationDate, true)}</Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2">Modification Date</Col><Col>{window.formatTimestamp(selectedObject.modificationDate, true)}</Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2">Last Access</Col><Col>{window.formatTimestamp(selectedObject.lastAccessDate, true)}</Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2">Last Metadata Change</Col><Col>{window.formatTimestamp(selectedObject.lastMetadataChangeDate, true)}</Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2">Ingested File CDate</Col><Col>{window.formatTimestamp(selectedObject.ingestedFileCDate, true)}</Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2">Ingested File MDate</Col><Col>{window.formatTimestamp(selectedObject.ingestedFileMDate, true)}</Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2">Ingested File ADate</Col><Col>{window.formatTimestamp(selectedObject.ingestedFileADate, true)}</Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2">File Extension</Col><Col>{selectedObject.fileExtension}</Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2">Creation Method</Col><Col>{selectedObject.creationMethod}</Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2">Gateway</Col><Col>{selectedObject.gateway}</Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2">Created By Program</Col><Col>{selectedObject.programUsedToCreate}</Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2">Mime Type</Col><Col>{selectedObject.mimeType}</Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2">Object ID</Col>
          <CopyToClipboard text={selectedObject.objectId} onCopy={() => this.context.postNotification('info', 'Object ID copied to paste buffer.')} >
            <Col><span title='Click to copy...'>{selectedObject.objectId}</span></Col>
          </CopyToClipboard>
        </Row>
      { ('cataloged' === this.props.viewType || 'uncataloged' === this.props.viewType) && 'N' === this.context.websiteProfile.captureAccessDetail &&
        <Row style={{paddingTop: "10px"}}>
          <Label for='captureDetails' sm="2" >Capture Access Detail?</Label>
          <Col sm="3" >
            <Input type="checkbox" id="captureDetails" name="captureDetails" onChange={this.toggleCaptureDetail}
              checked={('Y' === selectedObject.captureAccessDetail ? 'checked' : '')} style={{marginLeft: 0, marginTop: '0.7rem'}}
              title="Checking this box will cause the detail for all gateway access operations for this object to be captured."/>
          </Col>
        </Row >
      }
      { ('cataloged' === this.props.viewType || 'uncataloged' === this.props.viewType) &&
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2">Immutable Object</Col>
          <Col>
            <Form >
            <FormGroup check className="form-check-inline" style={{paddingTop: '.4rem'}}>
              <Input type="checkbox" id="immutableChkBox" name="immutableChkBox" onChange={this.toggleImmutable.bind(this, 'object')} 
                checked={'Y' === selectedObject.immutableObject ? "checked" : ""} />
            </FormGroup>
            </Form>
          </Col>
        </Row>
      }
      { ('cataloged' === this.props.viewType || 'uncataloged' === this.props.viewType) &&

        <Row style={{paddingTop: "10px"}}>
        <Col sm="2">Immutable Keywords</Col>
        <Col>
          <Form >
          <FormGroup check className="form-check-inline" style={{paddingTop: '.4rem'}}>
            <Input type="checkbox" id="immutableKeysChkBox" name="immutableKeysChkBox" onChange={this.toggleImmutable.bind(this, 'keywords')} 
              checked={'Y' === selectedObject.immutableKeywords ? "checked" : ""} />
          </FormGroup>
          </Form>
        </Col>
      </Row>
      }
      { ('deleted' !== this.props.viewType && null !== selectedObject.htmlElement) &&
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2">Delivery Method</Col>
          <Col>
            <Form  id="deliveryMethodControls">
              <FormGroup check className="form-check-inline">
                <Label check>
                  <Input type="radio" name="deliveryMethod" checked={('STREAM' === this.state.deliveryMethod ? 'checked' : '')} 
                      onChange={() => this.deliveryMethodChanged('STREAM')} />
                  Streaming
                </Label>
              </FormGroup>
              <FormGroup check className="form-check-inline">
                <Label check>
                  <Input type="radio" name="deliveryMethod" checked={('DOWNLOAD' === this.state.deliveryMethod ? 'checked' : '')} 
                      onChange={() => this.deliveryMethodChanged('DOWNLOAD')}  />
                  Download
                </Label>
              </FormGroup>
            </Form>
          </Col>
        </Row>
      } 
      { 'deleted' !== this.props.viewType &&
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2">Weblink</Col>
          <Col sm='9'>
            <CopyToClipboard text={'DOWNLOAD' === this.state.deliveryMethod ? this.state.downloadLink : this.state.streamLink} 
                onCopy={() => this.context.postNotification('info', 'Weblink copied to paste buffer.')} >
              <span title='Click to copy...'>{'DOWNLOAD' === this.state.deliveryMethod ? this.state.downloadLink : this.state.streamLink}</span>
            </CopyToClipboard>
          </Col>          
        </Row>
      }
      { window.extensionEnabled(this.context.websiteProfile.installedExtensions, this.context.extensions.OCIObjectStorage) &&
        'N' === this.props.selectedObject.versionedObject &&
        ('cataloged' === this.props.viewType || 'uncataloged' === this.props.viewType) &&
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2">Object Storage Status</Col>
          <Col>{this.props.selectedObject.objectStorageStatus}</Col>
          { 'Database' === this.props.selectedObject.objectStorageStatus && 
            <>
              <Col>
                <Button onClick={this.confirmCopyOrMove.bind(this, 'move')}>Move to Object Storage</Button>
                <Button onClick={this.confirmCopyOrMove.bind(this, 'copy')}>Copy to Object Storage</Button>
              </Col>
            </>
          }
        </Row>
      }
        {buttonBar}
        <ConfirmationModal modalIsOpen={this.state.confirmationModalIsOpen} closeModal={this.closeConfirmationModal}
          modalText={this.state.modalText}
        />
      </div>
    );
  }

  renderButtonBar(selectedObject)
  {
    return (
      <Row style={{paddingTop: "10px"}}>
        <Col sm={{ size: 9, offset: 2 }}>
          <ButtonToolbar>
            <ButtonGroup size='sm'>
            { 'deleted' !== this.props.viewType && '' !== this.context.appLocalStorage.getGatewayName() && 
               undefined !== window.getHelperApp(this.props.selectedObject.mimeType) &&
              <Button id="spawnHelperApplication" color='success' onClick={this.spawnHelperApplication}>Open W/ App</Button>
            }          
            { 'deleted' !== this.props.viewType &&              
              <a href={this.state.downloadLink} download={selectedObject.objectName}><Button color='primary' id="downloadObject">Download</Button></a> 
            }          
            { 'shared' !== this.props.viewType && 'Y' !== this.props.selectedObject.immutableObject &&
              <Button color={'deleted' === this.props.viewType ? 'success' : 'danger' } className="mr-auto" onClick={() => this.deleteRestoreOrPurge(('deleted' === this.props.viewType ? 'restore' : 'delete'))}>
                {this.deleteOrRestoreLabel}
              </Button>
            }
            { 'deleted' === this.props.viewType && 'Y' !== this.props.selectedObject.immutableObject &&          
              <Button color='danger' className="mr-auto" onClick={() => this.deleteRestoreOrPurge('purge')}>
                Purge
              </Button>
            }
            </ButtonGroup>
          </ButtonToolbar>
        </Col>
      </Row>
    );
  }

  async spawnHelperApplication()
  {
    let bodyData = {}
    bodyData.gatewayName = this.context.appLocalStorage.getGatewayName();
    bodyData.commandLine = window.getHelperApp(this.props.selectedObject.mimeType) + ' ' + this.state.streamLink;
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'spawnHelperApplication', bodyData);
    if ('success' !== result.status && this.context.dbTwig.GatewayOffline !== result.errorCode) 
      return this.context.dbTwig.apiErrorHandler(result, 'Error starting helper app.');

    if ('success' !== result.status && this.context.dbTwig.GatewayOffline === result.errorCode)
      this.context.postNotification('warning', 'Gateway offline.');

    if ('success' === result.status) this.context.postNotification('success', 'Helper application started.');
    this.props.refreshVaultViewTab();
  }

  setStorageTier(storageTier)
  {
    this.closeConfirmationModal = this.setStorageTierConfirmed.bind(this, storageTier);
    this.setState({modalText: 'Are you sure you want to change the storage tier for this object?', confirmationModalIsOpen: true});
  }

  setStorageTierConfirmed(storageTier, confirmed)
  {
    this.setState({confirmationModalIsOpen: false});
    if (!confirmed) return;

    this.props.setStorageTier(storageTier);
  }

  toggleCaptureDetail()
  {
    this.props.toggleCaptureDetail();
  }

  toggleImmutable(objectOrKeywords)
  {
    let modalText = ('Y' === this.props.selectedObject.immutableObject ?
      'Are you sure that you want to make this object mutable?  Doing so will allow changes to the content and deletion of the object.' :
      'Are you sure that you want to make this object immutable?  Doing so will prevent all changes to the object.');

    if ('keywords' === objectOrKeywords)
    {
      modalText = ('Y' === this.props.selectedObject.immutableKeywords ?
        'Are you sure that you want to make the keywords for this object mutable?  Doing so will allow changes to the keywords and tags for this object.' :
        'Are you sure that you want to make the keywords for this object immutable?  Doing so will prevent changes to the keywords and tags for this object.');
    }

    this.closeConfirmationModal = this.toggleImmutableConfirmed.bind(this, objectOrKeywords);
    this.setState({modalText: modalText, confirmationModalIsOpen: true});
  }

  toggleImmutableConfirmed(objectOrKeywords, confirmed)
  {
    this.setState({confirmationModalIsOpen: false});
    if (!confirmed) return;

    this.props.toggleImmutableObject(objectOrKeywords);
  }
}

ObjectProperties.contextType = AppContext;

export default ObjectProperties
